export const isPrimaryClick = (e) => {
    if (e.button) return e.button === 0;
    return true;
};

/**
 * Note: we want the starting point to be the top of the circle instead of the positive x-axis intercept, so we always
 * subtract 90 degrees from every progress point to make that happen
 * @param {number} percentProgress 0-1
 * @returns {number} Theta around the unit circle in radians
 */
const progressInRadians = (percentProgress: number): number => {
    // eslint-disable-next-line no-magic-numbers
    return (360 * percentProgress - 90) * (Math.PI / 180);
};

export const progressEndpoint = (percentProgress: number): { x1: number, y1: number } => {
    const MIDPOINT_OF_SVG = 15;
    const RADIUS_OF_PROGRESS_CIRCLE = 13;
    const theta = progressInRadians(percentProgress);
    const x1 = MIDPOINT_OF_SVG + RADIUS_OF_PROGRESS_CIRCLE * Math.cos(theta);
    const y1 = MIDPOINT_OF_SVG + RADIUS_OF_PROGRESS_CIRCLE * Math.sin(theta);
    return { x1: x1, y1: y1 };
};